<template>
  <header-bar />
  <main class="flex-shrink-0">
    <div class="container pb-5 bg-white">
      <router-view />
    </div>
  </main>
  <footer-bar />
</template>

<script>
import HeaderBar from './components/HeaderBar.vue';
import FooterBar from './components/FooterBar.vue';

export default {
  name: 'App',
  components: {
    HeaderBar,
    FooterBar
  }
}
</script>

<style scoped lang="scss">
@import './scss/theme.scss';

main > .container {
  padding-top: 60px;
}

</style>